import {computedAsync} from '@vueuse/core';
import {defineStore, storeToRefs} from 'pinia';
import {useUserStore} from './userStore';
import type {UserMeBookingFor} from '../api/models/user/userMeBookingForModel';
import {getUsersMeBookingForAllowed} from '../api/repositories/booking/BookingForRepository';
import {computed, ref, watch} from 'vue';

export const useBookingForStore = defineStore('bookingFor', () => {
    const {user, isAuthenticated} = storeToRefs(useUserStore());
    const userMeBookingForId = ref<string | null>(user.value?.id ?? null);

    const usersMeBookingForAllowed = computedAsync<UserMeBookingFor[]>(async () => {
        if (!isAuthenticated.value || !user.value?.id) {
            return [];
        }
        await Promise.resolve();
        return await getUsersMeBookingForAllowed();
    }, []);

    watch(user, user => {
        userMeBookingForId.value = user ? user.id : null;
    });

    const isSelfBooking = computed<boolean>(() => {
        return userMeBookingForId.value === user.value?.id;
    });

    const userMeBookingFor = computed(
        () =>
            usersMeBookingForAllowed.value.find(user => user.id === userMeBookingForId.value) ??
            null
    );

    return {userMeBookingForId, userMeBookingFor, usersMeBookingForAllowed, isSelfBooking};
});
